import { object, string, array } from 'yup';

export const SignupArtistIdentificationSchema = object().shape({
  identities: array().of(string().trim()).label('Cultural identity'),
  genders: array().of(string().trim()).label('Gender'),
  disability: string().trim().label('Disability'),
  sexualities: array().of(string().trim()).label('Sexual orientation'),
});
